module.exports = __webpack_public_path__ + "media/images/home-page/3-2@2x-a32e8f1a69efaaec67cbff5ed5bbdf8b.png";